module.exports = __webpack_public_path__ + "img/Axelerate_logo.bae74070.svg";